import { KeyValue } from '@angular/common';
import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { UntypedFormBuilder } from '@angular/forms';
import { RuleService } from '../rule/rule-custom-service';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
// import { LookBackComponent } from './lookback/lookback.component';
// import { LookbackalertComponent } from './lookbackalert/lookbackalert.component';
import { ErrorMsgHandler } from '../shared/errormanagement/handleerror';
import { RulevarService } from '../rule/rulevar.service';
import { QueryEditorService } from '../language-service/query-editor.service';
import { Router } from '@angular/router';
import { RoutecrumpsService } from '../services/routecrumps.service';
import { CdkOverlyayService } from 'src/app/shared/custom-overlay/cdk-overlyay.service';
import { TemplateDropdownComponent } from 'src/app/shared/custom-overlay/template-dropdown/template-dropdown.component';
import { cdkOverlayRef } from '../shared/custom-overlay/cdk-overlay-ref';
import { AlertsvarService } from '../alerts/alertsvar.service';
import { SharedService } from '../services/shared.service';
import { ToastService } from '../shared/custom-overlay/toast/toast.service';
import { AssetDropdownService } from '../shared/assets/assets-dropdown.service';
import { TemplateRef } from '@angular/core';
import { UserComponent } from '../settings/user/user.component';
import { CreateRuleComponent } from '../rule/create-rule/create-rule.component';
import { HomeComponent } from '../home/home.component';
import { ImportIntelListComponent } from './create-intel-list/import-intel-list/import-intel-list.component';
import * as XLSX from 'xlsx';
import { TimeZoneService } from '../services/time-zone.service';

//values assign for tab index
export enum SelectedIndex {
  view = 0,
  rule = 1
}

@Component({
  selector: 'app-intel-list',
  templateUrl: './intel-list.component.html',
  styleUrls: ['./intel-list.component.scss']
})
export class IntelListComponent implements OnInit, AfterViewInit, OnDestroy {

  labelName: string = this.rulevarservice.ruleMeta.headers[6];
  mat_spinner_create_state: boolean;
  mat_spinner_ruleList_state: boolean = false;
  mat_spinner_download: boolean =false

  destroy$: Subject<boolean> = new Subject()
  rulelisterrorinsatnce = new ErrorMsgHandler();
  createrule: cdkOverlayRef;
  overLayRef: cdkOverlayRef;
  @ViewChild('manualImportOrigin') manualImportOrigin: TemplateRef<any>;
  @ViewChild('enrichPopup') enrichPopup: TemplateRef<any>;
  @ViewChild('deletePopUp') deletePopUp: TemplateRef<any>;
  @ViewChild('deleteConfirmation') deleteConfirmation: TemplateRef<any>;
  dialogRef:any
  deleteList

  constructor(
    public matdialog: MatDialog,
    public fb: UntypedFormBuilder,
    private router: Router,
    private ruleService: RuleService,
    public rulevarservice: RulevarService,
    public cdkverlayDialog: CdkOverlyayService,
    private queryEditorService: QueryEditorService,
    private rcrumpService: RoutecrumpsService,
    private alertvarservice:AlertsvarService,
    public sharedService:SharedService,
    public toasterService:ToastService,
    public assetsService:AssetDropdownService,
    public timezoneservice: TimeZoneService
  ) { }

  async ngOnInit() {
    // await this.changePlatformFields('firewall_fortigate')
    // console.log(this.ruleService.providerulelist)
    // this.rulevarservice.ruleLandingchangeTab(0)
    this.refreshRuletable()
    // await this.rulevarservice.fetchIntelListName()
    // .then((value: any) => {
    //   Object.keys(value).forEach(key=>{
    //     this.rulevarservice.intelList.push({'listname':value[key].disp,"platform":"-","ttl":"-"})
    //   })
    //   this.rulevarservice.intelList = Array.from(new Map(this.rulevarservice.intelList.map(obj => [obj.listname, obj])).values());

      
       
    // })
    // this.rulevarservice.getTagsList()
//console.log("rulevarservice ===",this.rulevarservice)
    this.providerouteCrummp();
    // this.rulevarservice.intelList=JSON.parse(JSON.stringify(this.rulevarservice.intelListGet))

 
      // Object.keys(this.rulevarservice.intelList).forEach(obj=>{
        // this.rulevarservice.intelList[obj].ttl=this.timeformat(this.rulevarservice.intelListGet[obj].ttl,this.rulevarservice.intelListGet[obj].ttl_unit) as undefined as number
        // this.rulevarservice.intelList[obj].learning_period=this.timeformat(this.rulevarservice.intelListGet[obj].learning_period,this.rulevarservice.intelListGet[obj].learning_unit) as undefined as number
        // this.rulevarservice.intelList[obj].created_time=this.dateformat(this.rulevarservice.intelListGet[obj].created_time) as undefined as number
      // })
      // console.log(this.rulevarservice.intelList)
    
    // if (this.rulevarservice.ruleselectedIndex == 1) {
    //   this.router.navigateByUrl("rule/create");
    // }
    // this.rulevarservice.ruleitemperpage.valueChanges.pipe(distinctUntilChanged()).subscribe((dat) => {
    //   this.mat_spinner_ruleList_state = true;
    //   this.rulevarservice.ruleitemperpage.setValue(dat, { emitEvent: false });

    //   this.handlerulepagination();
    //   // this.handlerulerepopagination(); 
    //   // this.handleintelpagination();  // for intel list
    //   // setTimeout(() => {
    //   //   this.mat_spinner_ruleList_state = false;
    //   // }, 300)
    // })
    // this.rulevarservice.rulerepoitemperpage.valueChanges.pipe(distinctUntilChanged()).subscribe((dat) => {// for rules repo
    //   this.mat_spinner_ruleList_state = true;
    //   this.rulevarservice.rulerepoitemperpage.setValue(dat, { emitEvent: false });
    //   this.handlerulerepopagination();
    //   // setTimeout(() => {
    //   //   this.mat_spinner_ruleList_state = false;
    //   // }, 300)
    // })
    this.rulevarservice.intelitemperpage.valueChanges.pipe(distinctUntilChanged()).subscribe((dat) => {// for rules repo
      this.mat_spinner_ruleList_state = true;
      this.rulevarservice.intelitemperpage.setValue(dat, { emitEvent: false });
      this.handleintelpagination();
      // setTimeout(() => {
        this.mat_spinner_ruleList_state = false;
      // }, 300)
    })
    // console.log("RuleMeta",this.rulevarservice.ruleMeta)

    // this.rulevarservice.lookbackitemperpage.valueChanges.pipe((distinctUntilChanged())).subscribe((dat: any) => {
    //   this.handlelookbackPagination();
    // })

    // this.ruleService.providerulelist.isProgress$.subscribe((state: boolean) => {
    //   if (state) {
    //     this.rulevarservice.ruleitemperpage.disable({ emitEvent: false });
    //     this.rulevarservice.rulerepoitemperpage.disable({ emitEvent: false });
    //     this.rulevarservice.intelitemperpage.disable({ emitEvent: false });
    //     this.rulevarservice.lookbackitemperpage.disable({ emitEvent: false })
    //     this.mat_spinner_ruleList_state = state;
    //   } else {
    //     this.rulevarservice.ruleitemperpage.enable({ emitEvent: false });
    //     this.rulevarservice.rulerepoitemperpage.enable({ emitEvent: false });
    //     this.rulevarservice.intelitemperpage.enable({ emitEvent: false });
    //     this.rulevarservice.lookbackitemperpage.enable({ emitEvent: false });
    //   }
    // })
    if (this.ruleService.providerulelist.getemitstate()) {
      this.provideRuleStat();
      this.provideRuleData();
    } else {
      if (!this.ruleService.providerulelist.responsestate) {
        this.provideRuleStat();
        this.provideRuleData();
      } else {
        // this.mat_spinner_ruleList_state = false;
      }
      this.ruleService.providerulelist.emitstate = 1;
    }

//     this.rulevarservice.ruletablesearch.valueChanges
//       .pipe(debounceTime(300))
//       .subscribe((searchstr: string) => {
//         this.mat_spinner_ruleList_state = true;
//         this.filterRuleActiveList(searchstr)
//         this.filterruleList(searchstr);
//         this.handlerulepagination();
//         this.handlerulerepopagination();
//         // this.handleintelpagination();
//         setTimeout(() => { 
// //console.log("rulesearch")
//           this.mat_spinner_ruleList_state = false; }, 500)
//       })

    this.rulevarservice.inteltablesearch.valueChanges
      .pipe(debounceTime(300))
      .subscribe((searchstr: string) => {
//console.log({searchstr})
        // this.mat_spinner_ruleList_state = true;
        this.filterintelList(searchstr);
        
        // this.handlerulepagination();
        // this.handlerulerepopagination();
        this.handleintelpagination();

        // setTimeout(() => { 
          
          // if(this.rulevarservice.ruleselectedIndex == 2){
// console.log("intelsearch")
            // this.mat_spinner_ruleList_state = false;
        // }, 500)
        this.mat_spinner_ruleList_state=false
        
      })
      
  }

  ngAfterViewInit(): void { }

  providerouteCrummp() {
    this.rcrumpService.route_crumps[1] = {
      disp_str: "Intel List",
      routeTo: "intel-list",
      callback: null,
      isParent: true
    }
    this.rcrumpService.route_crumps.length = 2;
  }

  filterruleList(searchstr: string) {
    // this.mat_spinner_ruleList_state = true;
    this.rulevarservice.filteredruleList = this.rulevarservice.ruleList.filter((rule: any) => {
    
      if (
        this.rulevarservice.platformMap[rule.platform].toLowerCase().includes(searchstr.toLowerCase()) ||
        rule.ruleId.toLowerCase().includes(searchstr.toLowerCase()) ||
        rule.ruleName.toLowerCase().includes(searchstr.toLowerCase()) ||
        rule.ruleType.toLowerCase().includes(searchstr.toLowerCase())
      ) {
        return rule;
      }
    })
//console.log("filterRuleList")
    // this.mat_spinner_ruleList_state = false;

  
    //console.log("Filtered",this.rulevarservice.filteredruleList)
    this.rulevarservice.getTagsList()
  }

  filterRuleActiveList(searchstr: string) {
    // this.mat_spinner_ruleList_state = true;
    let list=[]
    this.rulevarservice.ruleList.forEach(data=>{
      if(data.status ===1){
        list.push(data)
      }
    })
    this.rulevarservice.ruleActiveList = list.filter((rule: any) => {
    
      if (
        this.rulevarservice.platformMap[rule.platform].toLowerCase().includes(searchstr.toLowerCase()) ||
        rule.ruleId.toLowerCase().includes(searchstr.toLowerCase()) ||
        rule.ruleName.toLowerCase().includes(searchstr.toLowerCase()) ||
        rule.ruleType.toLowerCase().includes(searchstr.toLowerCase())
      ) {
        return rule;
      }
    })
//console.log("filterActiveRuleList")
    // this.mat_spinner_ruleList_state = false;

  
    //console.log("Filtered",this.rulevarservice.filteredruleList)
    this.rulevarservice.getTagsList()
  }


  filterintelList(searchstr: string) {

    

    this.rulevarservice.intelList = this.rulevarservice.intelListGet.filter((list: any) => {
      // console.log(this.rulevarservice.platformMap)
      // console.log(list)
    
      if (
        // this.rulevarservice.platformMap[list.platform].toLowerCase().includes(searchstr.toLowerCase()) ||
        list.list_id.toString().toLowerCase().includes(searchstr.toLowerCase()) ||
        list.list_name.toLowerCase().includes(searchstr.toLowerCase()) 
        // rule.ruleType.toLowerCase().includes(searchstr.toLowerCase())
      ) {
        return list;
      }
      // this.mat_spinner_ruleList_state=false
    })

  
    
//console.log("Filtered",this.rulevarservice.intelList)
//console.log("filter->",this.rulevarservice.intelList)
    // this.rulevarservice.getTagsList()
  }

  //unsort the key value from the array of objects
  originalOrder = (a: KeyValue<number, string>, b: KeyValue<number, string>): number => {
    return 0;
  }

  handlerulepagination() {
    const pagelength =
      // Math.ceil(this.rulevarservice.filteredruleList.length / this.rulevarservice.ruleitemperpage.getRawValue());
      Math.ceil(this.rulevarservice.ruleActiveList.length / this.rulevarservice.ruleitemperpage.getRawValue());
    if (pagelength) {
      this.rulevarservice.rulepagelength = pagelength;
    } else {
      this.rulevarservice.rulepagelength = 1;
    }
    if (
      (this.rulevarservice.rulepagenumber > this.rulevarservice.rulepagelength)
    ) {
      this.rulevarservice.rulepagenumber = this.rulevarservice.rulepagelength;
    }
//console.log("handlePagination")
    this.mat_spinner_create_state=false
   
    
  }
  handlerulerepopagination() {
    const pagelength =
      Math.ceil(this.rulevarservice.filteredruleList.length / this.rulevarservice.rulerepoitemperpage.getRawValue());
      // console.log({pagelength})
    if (pagelength) {
      this.rulevarservice.rulerepopagelength = pagelength;
    } else {
      this.rulevarservice.rulerepopagelength = 1;
    }
    if (
      (this.rulevarservice.rulerepopagenumber > this.rulevarservice.rulerepopagelength)
    ) {
      this.rulevarservice.rulerepopagenumber = this.rulevarservice.rulerepopagelength;
    }
//console.log("rulerepo")
    this.mat_spinner_create_state=false
  }
  handleintelpagination() {
    const pagelength =
      Math.ceil(this.rulevarservice.intelList.length / this.rulevarservice.intelitemperpage.getRawValue());
    if (pagelength) {
      this.rulevarservice.intelpagelength = pagelength;
    } else {
      this.rulevarservice.intelpagelength = 1;
    }
    if (
      (this.rulevarservice.intelpagenumber > this.rulevarservice.intelpagelength)
    ) {
      this.rulevarservice.intelpagenumber = this.rulevarservice.intelpagelength;
    }
    // console.log("intelPagination")
    // this.mat_spinner_create_state=false
  }


  handlelookbackPagination() {
    const pagelength = Math.ceil(this.rulevarservice.lookbacklist.length / this.rulevarservice.lookbackitemperpage.value);
    if (pagelength) {
      this.rulevarservice.lookbackpagelength = pagelength;
    } else {
      this.rulevarservice.lookbackpagelength = 1;
    }
    if (this.rulevarservice.lookbackpagenumber > this.rulevarservice.lookbackpagelength) {
      this.rulevarservice.lookbackpagenumber = this.rulevarservice.lookbackpagelength;
    }
  }

  async changePlatformFields(platform){
    // console.log(this.platform.value)
    await this.fetchPlatformFields(platform)
    .then((platformfields: any) => {
//console.log({platformfields})
      if (platformfields.platform_fields) {
        this.rulevarservice.fieldsList = this.rulevarservice.commonFieldsEntityCheck(JSON.parse(JSON.stringify(platformfields.platform_fields)));
        this.rulevarservice.total_agg_fields=this.rulevarservice.commonFieldsEntityCheck(JSON.parse(JSON.stringify(platformfields.platform_fields)));
        this.rulevarservice.totalPlatformFields=this.rulevarservice.commonFieldsEntityCheck(JSON.parse(JSON.stringify(platformfields.platform_fields)));
        // this.totalPlatformFields=this.rulevarservice.commonFieldsEntityCheck(JSON.parse(JSON.stringify(platformfields.platform_fields)));
        this.rulevarservice.listFields=this.rulevarservice.commonFieldsEntityCheck(JSON.parse(JSON.stringify(platformfields.platform_fields)));
//console.log("Before",this.rulevarservice.ruleForm.get('actions').get('enrich'))
        this.rulevarservice.ruleForm.get('actions').get('enrich').updateValueAndValidity()
//console.log("After",this.rulevarservice.ruleForm.get('actions').get('enrich'))

      }
    })
  }

  fetchPlatformFields(platform: string) {
    return this.assetsService.getCommonPlatformFields({ 'platform': platform }).toPromise()
  }

  

  //triggred for every tab changes
  changeTab(event: number) {
    if (event == 1) {
      // this.router.navigateByUrl("rule/create")
    }
    // this.rulevarservice.ruleselectedIndex = event;
  }
  opencreate(){
    this.router.navigateByUrl("rule/create")
  }
  openAlertEdit(){
      this.router.navigateByUrl("auto-investigate-rule")
  }
  openAutoClosure(){
    this.router.navigateByUrl("alerts/auto-closure-rule")
  }
  clickcreate(type){
    // this.router.navigateByUrl("rule/create")
    this.createrule.close()
    this.rulevarservice.setRuleType(type.value);
    this.opencreate()
    
  }
  async intelOptionClick(option,intelDetail,origin){
    // console.log({origin})
    this.createrule.close()
    this.rulevarservice.importDetail=intelDetail
    // if(option.value =="import_manually" || option.value =="import_file"){
    //   this.importTableGet(intelDetail.list_id,intelDetail.list_type)
    // }
    if(option.value =="import_manually" || option.value == "import_file"){
      this.importTableGet(intelDetail.list_id,intelDetail.list_type,option.value,origin)
      // this.openImportManual()
    }else if(option.value == 'browse'){
      this.router.navigateByUrl('/intel-list/view-intel-list')
      this.rulevarservice.viewIntel=intelDetail
      // console.log(this.rulevarservice.viewIntel)
    }else if(option.value == 'download'){
      this.downloadClick(intelDetail)
    }else if(option.value == 'delete'){
      this.deleteListCheck(intelDetail)
    }
  }

  deleteListCheck(intelDetail){ //Check Intel list to delete
    // console.log(intelDetail)
    this.deleteList=intelDetail
    if(intelDetail.referenced){
      this.openDeletePopup()
    }else{
      this.openDeleteConfirmPopup()
    }
  }

  async deleteListClick(){ // Delete intel list
//console.log("Delete")
//console.log(this.deleteList)
    let postObj={"list_id":this.deleteList.list_id,"list_name": this.deleteList.list_name}
    // await this.ruleService.postIntelListDelete.postrequest(postObj)
    // .then((dat: any) => {
    //   if(dat){
    //     if(dat.status == 0){
    //       this.open_toaster('List cannot be deleted', 'failure')
    //     }else{
          this.open_toaster('Deleted successfully', 'success');
          this.provideIntelData()
    //     }
    //   }
    // }).catch(err => {
    //     this.open_toaster('Cannot be deleted', 'failure')
    //   })
  }


  openImportManual(data,origin) { 
    // console.log({origin})
    // console.log("impactedHost===>",this.impactedHost.value,"\nPlatform===>",this.platform.value)
    
    this.openOverlay(  'manual',
      ["auto", "auto"],origin
    );
    // this.editorchild.assetPlatformGrammer()
  }
  openImportFile(data,origin){
    this.openOverlay(  'import',
      ["auto", "auto"],origin
    );
  }

  openOverlay( data, dimensions,origin) {
    // console.log({data})
    // console.log({origin})
    // console.log(this.matdialog,ImportIntelListComponent)
    const dialogRef = this.matdialog.open(ImportIntelListComponent, {
      width: "auto", height: "auto", data: data, autoFocus: false,
      disableClose: false
    })
    // console.log(dialogRef)

    // console.log(dialogRef.afterClosed())
    
    dialogRef.afterClosed().subscribe(val=>{
      // console.log("Closed")
      this.refreshRuletable()
    })


    // this.overLayRef = this.cdkverlayDialog.open({
    //   data: data,
    //   height: dimensions[0],
    //   width: dimensions[1],
    // },
    //   origin, ImportIntelListComponent)
    return this.overLayRef;
  }

  dateformat(epochInSeconds) {
    const d = new Date(epochInSeconds * 1000);
  
    const day = String(d.getUTCDate()).padStart(2, '0');
    const month = String(d.getUTCMonth() + 1).padStart(2, '0');
    const year = d.getUTCFullYear();
  
    const hours = String(d.getUTCHours()).padStart(2, '0');
    const minutes = String(d.getUTCMinutes()).padStart(2, '0');
    // const seconds = String(d.getUTCSeconds()).padStart(2, '0');
  
    return `${day}-${month}-${year} ${hours}:${minutes}`;
  }
  formatDate(input) {
    const clean = input.replace(/\.\d+/, "");
  
    const date = new Date(clean);
  
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const yyyy = date.getFullYear();
  
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
  
    return `${dd}-${mm}-${yyyy} ${minutes}:${seconds}`;
  }

  timeformat(time,unit){
    if(time){
      if(unit === 86400 || unit ==null){
        time=time/86400
        if(time === 1){
          return time+' Day'
        }else{
          return time+' Days'
        }
      }else if(unit === 3600){
        time=time/3600
        if(time === 1){
          return time+' Hour'
        }else{
          return time+' Hours'
        }
      }else{
        time=time/60
        if(time === 1){
          return time+' Min'
        }else{
          return time+' Mins'
        }
      }
    }else{
      return "-"
    }
  }

  opencreateintel(){
//console.log("Create intel List")
    this.router.navigateByUrl("intel-list/create-intel-list")
  }

  openSourceMenu_click(template: any, origin: any) {
    let config = {
      data: {
        "template": template,
      }
    }
    // this.cdkverlayDialog.openMenu(config, TemplateDropdownComponent, origin);
    this.createrule=this.cdkverlayDialog.openMenu(config, TemplateDropdownComponent, origin);
  }

  // openPlaybackRule(ruleId: string, platform: string, lookbackprogress: number, event) {
  //   event.stopPropagation()
  //   if (lookbackprogress == -1) {
  //     const dialogref = this.matdialog.open(LookBackComponent,
  //       {
  //         autoFocus: false,
  //         data: { timeoptions: this.rulevarservice.ruleMeta.lookbackmeta.timeoptions, ruleId: ruleId, lookbackmeta: this.rulevarservice.ruleMeta.lookbackmeta },
  //         width: '80%',
  //         height: '60vh'
  //       }
  //     )
  //     dialogref.afterClosed().subscribe((dat: any) => {
  //       if (dat) {
  //         this.lookbackposted()
  //       }
  //     })
  //   } else if (lookbackprogress == 1 || lookbackprogress == 2) {
  //     this.openlookbackview(ruleId, platform, lookbackprogress)
  //   }
  // }

  lookbackposted() {
    this.provideRuleData();
  }
  
  provideIntelData(){
    this.mat_spinner_ruleList_state=true
    this.ruleService.provideintellist.postrequest({ metakey: "all" })
    .pipe(takeUntil(this.destroy$))
    .subscribe((dat: any) => {
      if (dat) {
        this.rulevarservice.intelListGet = dat;
        this.rulevarservice.intelListEnrich=dat
//console.log("IntelData",this.rulevarservice.intelListGet)
        // this.processlookbackdata(dat.ruleList);
        // this.rulevarservice.ruletablesearch.setValue("");
        this.rulevarservice.inteltablesearch.setValue("");
        // this.handlerulepagination();
        // this.handlerulerepopagination();
        this.handleintelpagination();
        // this.handlelookbackPagination();
      }
      this.rulelisterrorinsatnce.seterror(false, '');
//console.log(this.rulevarservice.intelListGet)
//console.log(this.rulevarservice.intelList)
      // this.mat_spinner_ruleList_state=false
    }, (err) => {
//console.log("intelerror")
      this.mat_spinner_ruleList_state = false;
      this.rulevarservice.intelpagelength = 1;
      this.rulevarservice.intelpagenumber = 1;
      this.rulelisterrorinsatnce.seterror(true, err.error?.errmsg);
  })
  }

  getRuleActiveList(){

    this.rulevarservice.ruleList.forEach(list=>{
      if(list.status === 1){
        this.rulevarservice.ruleActiveList.push(list)
      }
    })
    // console.log("activeRule")
    // this.mat_spinner_ruleList_state=false

  }

  provideRuleData() {
    // this.mat_spinner_ruleList_state = true;
    this.rulevarservice.ruleList.length = 0;
    this.rulevarservice.ruleActiveList.length = 0;
    this.rulevarservice.filteredruleList.length = 0;
    this.rulevarservice.lookbacklist.length = 0;
    
    this.rulevarservice.rulepagenumber = this.rulevarservice.lookbackpagenumber = 1;
    // this.mat_spinner_ruleList_state=true
//     this.ruleService.providerulelist.postrequest({ metakey: "all" })
//       .pipe(takeUntil(this.destroy$))
//       .subscribe((dat: any) => {
//         if (dat.ruleList) {
//           this.rulevarservice.ruleList = [...dat.ruleList];
//           this.getRuleActiveList()
//           // console.log("RuleData",this.rulevarservice.ruleList)
//           this.processlookbackdata(dat.ruleList);
//           this.rulevarservice.ruletablesearch.setValue("");
//           // this.rulevarservice.inteltablesearch.setValue("");
//           this.handlerulepagination();
//           this.handlerulerepopagination();
//           // this.handleintelpagination();
//           this.handlelookbackPagination();
//           // this.mat_spinner_ruleList_state = false;
//         }
//         // this.mat_spinner_ruleList_state=false
//         this.rulelisterrorinsatnce.seterror(false, '');
//       }, (err) => {
        
//         this.rulevarservice.rulepagelength = 1;
//         this.rulevarservice.rulepagenumber = 1;
// //console.log("error")
//         // this.mat_spinner_ruleList_state = false;
//         this.rulelisterrorinsatnce.seterror(true, err.error?.errmsg);
//     })
    // this.ruleService.provideintellist.postrequest({ metakey: "all" })
    //   .pipe(takeUntil(this.destroy$))
    //   .subscribe((dat: any) => {
    //     if (dat) {
    //       this.rulevarservice.intelListGet = [...dat];
    //       // console.log("RuleData",this.rulevarservice.ruleList)
    //       // this.processlookbackdata(dat.ruleList);
    //       // this.rulevarservice.ruletablesearch.setValue("");
    //       this.rulevarservice.inteltablesearch.setValue("");
    //       // this.handlerulepagination();
    //       // this.handlerulerepopagination();
    //       this.handleintelpagination();
    //       this.handlelookbackPagination();
    //     }
    //     this.rulelisterrorinsatnce.seterror(false, '');
    //   }, (err) => {
    //     this.mat_spinner_ruleList_state = false;
    //     this.rulevarservice.intelpagelength = 1;
    //     this.rulevarservice.intelpagenumber = 1;
    //     this.rulelisterrorinsatnce.seterror(true, err.error?.errmsg);
    // })
  }

  //on pagination arrow click
  rulepaginationTable_click(direction: number) {
    if (!this.mat_spinner_ruleList_state) {
      let pagevalue = this.rulevarservice.rulepagenumber;
      if (direction == -1) {
        if (pagevalue > 1) {
          this.startspinnerforpagination();
          this.rulevarservice.rulepagenumber = this.rulevarservice.rulepagenumber - 1;
        }
      } else {
        if (pagevalue < this.rulevarservice.rulepagelength) {
          this.startspinnerforpagination();
          this.rulevarservice.rulepagenumber = this.rulevarservice.rulepagenumber + 1;
        }
      }
    }
  }
  rulerepopaginationTable_click(direction: number){ // For rules repo
    if (!this.mat_spinner_ruleList_state) {
      let pagevalue = this.rulevarservice.rulerepopagenumber;
      if (direction == -1) {
        if (pagevalue > 1) {
          this.startspinnerforpagination();
          this.rulevarservice.rulerepopagenumber = this.rulevarservice.rulerepopagenumber - 1;
        }
      } else {
        if (pagevalue < this.rulevarservice.rulerepopagelength) {
          this.startspinnerforpagination();
          this.rulevarservice.rulerepopagenumber = this.rulevarservice.rulerepopagenumber + 1;
        }
      }
    }
  }
  intelpaginationTable_click(direction: number){ // For Intel List
    if (!this.mat_spinner_ruleList_state) {
      let pagevalue = this.rulevarservice.intelpagenumber;
      if (direction == -1) {
        if (pagevalue > 1) {
          this.startspinnerforpagination();
          this.rulevarservice.intelpagenumber = this.rulevarservice.intelpagenumber - 1;
        }
      } else {
        if (pagevalue < this.rulevarservice.intelpagelength) {
          this.startspinnerforpagination();
          this.rulevarservice.intelpagenumber = this.rulevarservice.intelpagenumber + 1;
        }
      }
    }
  }

  startspinnerforpagination() {
    this.mat_spinner_ruleList_state = true;
    // setTimeout(() => {
//console.log("pagination")
      this.mat_spinner_ruleList_state = false;
    // }, 2500)
  }

  processlookbackdata(rulelist: any[]) {
    for (let i = 0; i < rulelist.length; i++) {
      if (rulelist[i].lookbackprogress !== -1) {
        this.rulevarservice.lookbacklist.push(rulelist[i]);
      }
    }
  }

  lookbackpaginationTable_click(direction: number) {
    if (!this.mat_spinner_ruleList_state) {
      const pagevalue = this.rulevarservice.lookbackpagenumber;
      if (direction == -1) {
        if (pagevalue > 1) {
          // this.startspinnerforpagination();
          this.rulevarservice.lookbackpagenumber -= 1;
        }
      } else {
        if (pagevalue < this.rulevarservice.lookbackpagelength) {
          // this.startspinnerforpagination();
          this.rulevarservice.lookbackpagenumber += 1;
        }
      }
    }
  }

  deleteLookback(ruleid: string) {
    this.mat_spinner_create_state = true;
    this.ruleService.postlookbackdelete.postrequest({ ruleid }).subscribe((val: any) => {
      if (val.status) {
        this.lookbackposted();
        this.mat_spinner_create_state = false;
      }
    }, (err) => {
      this.mat_spinner_create_state = false;
    })
  }



  //on edit button click
  async openEdit_click(ruleId: string, lookbackstatus: number, status: number, event,ruleType:string,builtin) {
//console.log("RuleType",ruleType)
    if(ruleType==="auto_investigate" || ruleType=="auto_closure"){
      // this.openAlertEdit()
      this.alertvarservice.editState=true
      event.stopPropagation()
      if (lookbackstatus && (status == 0 || status == 1)) {
        // console.log("inside if",ruleId)
        this.mat_spinner_create_state = true;
        await this.ruleService.provideAlertEdit({ ruleId }).pipe(takeUntil(this.destroy$)).toPromise()
          .then(async (dat: any) => {
//console.log("AlertGet",dat)
            await this.ruleService.provideEventField({ 'platform': dat.platform })
              .pipe(takeUntil(this.destroy$)).toPromise()
              .then(async (data: any) => {
                // console.log("inside await 2")
                if (data.platform_fields) {
                  // console.log("inside await 2 if")
                  this.rulevarservice.processPlatformFields(data.platform_fields);
                }
                // this.queryEditorService.processFields(this.rulevarservice.platformFields);
                this.rulevarservice.editdatatocheckchanges = { ...dat };
                // this.rulevarservice.editState = true;
                this.alertvarservice.editState = true
                // this.rulevarservice.editrequested.state = true;
                // this.rulevarservice.editrequested.value = dat;
                this.alertvarservice.editrequested.state = true;
                this.alertvarservice.editrequested.value = JSON.parse(JSON.stringify(dat));
//console.log("Dat>>>>>>",dat)
                /* if (dat.context.ruleType === 'built_in'){
                  this.ruleComponent.ruleTypeOption = this.rulevarservice.ruleMeta.context.ruleType.options;
                  this.ruleComponent.readonly = true;
                  this.ruleComponent.editorchild.readonly = true;
                  setTimeout(()=>{
                    this.ruleComponent.ruleType.setValue(dat.context.ruleType,{emitEvent:false});
                  },0)
                } */
//console.log("EditSend======>>>>>>>",this.rulevarservice.editSend)
                this.rulevarservice.editSend['ruleId'] = ruleId;
                //this.ruleComponent.manageEdit(dat);
                //this.labelName = this.rulevarservice.ruleMeta.headers[7];
//console.log("selectedindex===========>>>>>>>",SelectedIndex.rule)
                this.rulevarservice.ruleselectedIndex = SelectedIndex.rule;
                this.alertvarservice._alert.next({ ...dat, ...{ alertId: dat["ruleFor"] } })
                // this.opencreate()
                if(ruleType==="auto_investigate"){
                  this.openAlertEdit()
                }
                else if(ruleType==="auto_closure"){
                  this.openAutoClosure()
                }
                this.mat_spinner_create_state = false;
              })
              .catch((err) => {
                this.mat_spinner_create_state = false;
              })
          })
          .catch((error) => {
            this.mat_spinner_create_state = false;
          })
      }
    }
    else{
      event.stopPropagation()
      if(!builtin){
        if (lookbackstatus && (status == 0 || status == 1)) {
          // console.log("inside if",ruleId)
          this.mat_spinner_create_state = true;
          await this.ruleService.provideEdit({ ruleId }).pipe(takeUntil(this.destroy$)).toPromise()
            .then(async (dat: any) => {
              // console.log("inside await 1")
              await this.ruleService.provideEventField({ 'platform': dat.context.platform })
                .pipe(takeUntil(this.destroy$)).toPromise()
                .then(async (data: any) => {
                  // console.log("inside await 2")
                  if (data.platform_fields) {
                    // console.log("inside await 2 if")
                    this.rulevarservice.processPlatformFields(data.platform_fields);
                  }
                  this.queryEditorService.processFields(this.rulevarservice.platformFields);
                  this.rulevarservice.editdatatocheckchanges = { ...dat };
                  this.rulevarservice.editState = true;
                  this.rulevarservice.editrequested.state = true;
                  this.rulevarservice.editrequested.value = dat;
  //console.log("Dat>>>>>>",dat)
                  /* if (dat.context.ruleType === 'built_in'){
                    this.ruleComponent.ruleTypeOption = this.rulevarservice.ruleMeta.context.ruleType.options;
                    this.ruleComponent.readonly = true;
                    this.ruleComponent.editorchild.readonly = true;
                    setTimeout(()=>{
                      this.ruleComponent.ruleType.setValue(dat.context.ruleType,{emitEvent:false});
                    },0)
                  } */
  //console.log("EditSend======>>>>>>>",this.rulevarservice.editSend)
                  this.rulevarservice.editSend['ruleId'] = ruleId;
                  //this.ruleComponent.manageEdit(dat);
                  //this.labelName = this.rulevarservice.ruleMeta.headers[7];
  //console.log("selectedindex===========>>>>>>>",SelectedIndex.rule)
                  this.rulevarservice.ruleselectedIndex = SelectedIndex.rule;
                  this.opencreate()
                  this.mat_spinner_create_state = false;
                })
                .catch((err) => {
                  this.mat_spinner_create_state = false;
                })
            })
            .catch((error) => {
              this.mat_spinner_create_state = false;
            })
        }
      }
    }
  }

  /* changeLabeNameFromChild() {
    this.labelName = this.rulevarservice.ruleMeta.headers[7];
  } */

  provideRuleStat() {
    this.ruleService.providerulestat.postrequest({ "ruleId": "all" }).pipe(takeUntil(this.destroy$)).subscribe(dat => {
      this.rulevarservice.ruleStat = dat;
//console.log("---->>>>",this.rulevarservice.ruleStat)
    });
    
  }

  /* spinnerOutputFromChild(val: boolean) {
    this.mat_spinner_create_state = val
  } */

  /* ruleSaved_fromChild(postDetail: number[]) {
    if (!this.rulevarservice.editState) {
      this.ruleComponent.manageDelete(this.rulevarservice.ruleMeta.ruledefault)
    }
    this.rulevarservice.ruleselectedIndex = SelectedIndex.view;
    this.mat_spinner_create_state = false;
    if (postDetail[0] == 1) {
      this.open_toaster(this.rulevarservice.ruleMeta.postmsg[1], 'success');
      this.provideRuleStat();
      this.provideRuleData();
    } else if (!postDetail[0] && !postDetail[1]) {
      this.open_toaster(this.rulevarservice.ruleMeta.postmsg[0], 'failure')
    }
  } */

  refreshRuletable() {
    if (!this.mat_spinner_ruleList_state) {
      // this.mat_spinner_ruleList_state = true;
      this.ruleService.providerulelist.refresh();
      this.ruleService.provideintellist.refresh();
      this.provideIntelData()
      // this.provideRuleData();
      // this.mat_spinner_ruleList_state = false;
      
      
    }
  }

  ruleLandingchangeTab(event: number) {
    this.rulevarservice.ruleselectedIndex=event
    this.refreshRuletable()
   }

  open_toaster(msg: string, type: any) {
    this.toasterService.show({
      text: msg,
      type: type
    })
  } 

 

  // openlookbackview(ruleId: string, platform: string, progress: number) {
  //   if (progress == 1 || progress == 2) {
  //     this.matdialog.open(LookbackalertComponent, {
  //       width: "80%", height: "90vh", autoFocus: false,
  //       data: {
  //         "lookbackalertMeta": this.rulevarservice.ruleMeta.lookbackmeta.lookbackAlerttable,
  //         "pagination": this.rulevarservice.commonData.pagination,
  //         "ruleId": ruleId, "platform": platform, "alertmeta": { 'mapping': this.rulevarservice.ruleMeta.lookbackmeta.mapping, 'headers': this.rulevarservice.ruleMeta.lookbackmeta.headers }
  //       }
  //     })
  //   };
  // }
  async intelEditClick(listname,id,type){ // Intel list edit get 
//console.log({type})
    if(type == "Custom"){
      this.rulevarservice.intelEditMode=true
//console.log("is Edit ->",this.rulevarservice.intelEditMode)
      this.mat_spinner_create_state = true;
        await this.ruleService.provideIntelEdit(id).pipe(takeUntil(this.destroy$)).toPromise()
          .then(async (dat: any) => {
            
            this.rulevarservice.intelEditMode=true
            this.rulevarservice.ruleselectedIndex = SelectedIndex.rule;
            
              this.rulevarservice.intelEditValue=dat
              this.opencreateintel()
              this.mat_spinner_create_state = false;

          })
          .catch((err) => {
            this.mat_spinner_create_state = false;
          })
    }else{
    this.open_toaster('Built-in lists are not editable','warning')
    }
  }
  async importTableGet(list_id,type,importMode,origin){ //get table details for import
    // console.log({origin})
//console.log({list_id})
    if(type === "Custom"){
      this.mat_spinner_create_state = true;
        await this.ruleService.provideImportTable(list_id).pipe(takeUntil(this.destroy$)).toPromise()
          .then( (dat: any) => {
            // console.log({dat})
            // console.log(this.checkEnrichable(dat.table))
            this.rulevarservice.importTable=JSON.parse(JSON.stringify(dat.table))
            if(this.checkEnrichable(dat.table)){ // Check if the columns in the table are enrichable
              this.openEnrichPopup()
            }else{
              if(importMode === "import_manually"){
                this.openImportManual([dat.table,this.rulevarservice.importDetail],origin)
              }else if(importMode === "import_file"){
                this.openImportFile([dat.table,this.rulevarservice.importDetail],origin)
              }
            }
              // this.router.navigateByUrl("intel-list/import-intel-list")
                this.mat_spinner_create_state = false;
              })
              .catch((err) => {
                this.mat_spinner_create_state = false;
          })
      }
  }

  checkEnrichable(table){ // Check table for Enrichable columns
    let enrich=true
    table.forEach(list=>{
      if(!list.enrichable){
        enrich=false
      }
    })
    return enrich
  }

  openEnrichPopup() { 
    const dialogRef: MatDialogRef<any> = this.matdialog.open(this.enrichPopup, {
      width: '39vw',  
      height: '19vh'     
    });
    this.dialogRef=dialogRef
  }

  openDeletePopup() { 
    const dialogRef: MatDialogRef<any> = this.matdialog.open(this.deletePopUp, {
      width: '39vw',  
      height: '16vh'     
    });
    this.dialogRef=dialogRef
  }

  openDeleteConfirmPopup() { 
    const dialogRef: MatDialogRef<any> = this.matdialog.open(this.deleteConfirmation, {
      width: '39vw',  
      height: '16vh'     
    });
    this.dialogRef=dialogRef
  }

  enrichYes(){
    this.dialogRef.close()
  }

  deleteYes(){
    this.dialogRef.close()
  }

  deleteConfirmNo(){
    this.dialogRef.close()
  }

  deleteConfirmYes(){
    this.deleteListClick()
    this.dialogRef.close()
  }

  async downloadClick(intelDetail){
    let reqObj={"list_name":intelDetail.list_name,"list_id":intelDetail.list_id}
    this.mat_spinner_download = true
    await this.ruleService.provideintellistview.postrequest(reqObj) .pipe(takeUntil(this.destroy$))
    .subscribe((dat: any) => {
      if(dat){
        if(dat.field_values.length){
          this.toasterService.ShowToaster("Downloaded successfully","success")
          this.exportExcel(dat.field_values,intelDetail.list_name)
        }else{
          this.mat_spinner_download = false
          this.toasterService.ShowToaster("No data available to download.","warning")
        }
      }
    } ,(err) => {
      this.mat_spinner_download = false
      this.toasterService.ShowToaster("Download failed.","failure")
    })
  }

  exportExcel(data,listName): void { // download Excel
    // const data = [
    //   { Name: 'Alice', Age: 25 },
    //   { Name: 'Bob', Age: 30 }
    // ];
  
    // Convert JSON to worksheet
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
  
    // Create workbook
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Users');
  
    // Generate buffer
    const excelBuffer: any = XLSX.write(wb, {
      bookType: 'xlsx',
      type: 'array'
    });
  
    // Create blob
    const blob = new Blob([excelBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
    });
  
    // Trigger download
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = listName+"_"+this.timezoneservice.getcurrentuserTime().format("DDMMYYYY")+'.xlsx';
    link.click();
  
    URL.revokeObjectURL(link.href);
    this.mat_spinner_download = false
  }
   
  

  ngOnDestroy(): void {
    // this.ruleService.componentdestroyed.next(0);
    this.deleteList={}
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
